<template>
  <div class="wrap">
    <div class="insidebanner">
      <img src="../assets/case/banner.png" alt="" />
      <!-- <span class="halo"></span> -->
      <span class="insidebanner-bor"></span>
    </div>
    <div class="content">
      <div class="success">
        <div class="title">
          <h4>成功合作案例</h4>
          <img src="../assets/case/title_01.png" alt="" />
        </div>
        <div class="success-bgc">
          <div class="success-cont">
            <div class="swiper-container swiper-success">
              <div class="swiper-wrapper">
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/02.png" alt="" /></dt>
                  <dd>
                    <h4>河北沧州合伙人园所</h4>
                    <p>
                      建筑面积3500平米，室外活动4500平米，可接收300名学生，满员年营业额将达1200万以上；
                    </p>
                    <p>
                      打造烹饪教室、游泳池、多功能厅、音乐室、阅读室、市内运动场等一系列特色设施；
                    </p>
                    <p>使用合伙人国际英语和蒙氏课程作为幼儿园特色课程；</p>
                    <p>
                      招生阶段，合伙人深入市调，推荐有效招生方案，开业即取得不俗的招生成绩；
                    </p>
                    <p>
                      后续运营支持的持续跟进，园所稳步运营，打造成当地具有竞争力的高端园所。
                    </p>
                  </dd>
                </dl>
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/03.png" alt="" /></dt>
                  <dd>
                    <h4>奥斯顿幼儿园</h4>
                    <p>
                      奥斯顿幼儿园是KA旗下，在鄂尔多斯地区第一所品牌园；幼儿园占地面积6000多平方米，其园所布局由伊顿总部亲自指导设计，依托多年国际幼儿园教育经验，致力于打造鄂尔多斯首屈一指的国际性示范园。
                    </p>
                    <p>
                      于打造鄂尔多斯首屈一指的国际性示范园。奥斯顿幼儿园课程设计方面，既保持了伊顿“融合式主题课程、KA国际英语、生活艺术家、科学探索”等品牌优势课程；同时又增加了“陶艺、木工、纸艺、农工、茶道、插花、经典诵读”等传统文化特色课程；以及“奥尔夫音乐、剪纸、高尔夫球”等国际化启蒙课程。通过丰富的社会实践活动，树立幼儿不同于传统的书面世界观与价值观，进而培养出“自主的学习者、机敏的思考者、有创造力的问题解决者”同时，让“富有同理心、坚毅而阳光的奥斯顿精神”散播到每一个幼儿的身上，培养出真正的Alston(贵族)精神。
                    </p>
                  </dd>
                </dl>
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/04.png" alt="" /></dt>
                  <dd>
                    <h4>乐智KA儿童之家</h4>
                    <p>
                      乐智KA儿童之家，园所整体占地面积3600平米，地址位于榆次新建北路与文苑街交叉口（原紫云轩）。外教陪伴式教育，为孩子提供更好的外语环境，宽敞的教室，广阔的活动场地，简洁大气的建筑风格，优质的教育，是晋中市首屈一指的国际幼儿园。
                    </p>
                    <p>
                      园所秉承着“乐智·KA儿童之家的孩子就是我的孩子”的教育理念，以蒙台梭利教学为特色，国学文化为亮点，结合九大特色课及3C教育方式，为孩子提供良好的生活和成长环境；为家长提供值得信赖的家园服务！
                    </p>
                  </dd>
                </dl>
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/05.png" alt="" /></dt>
                  <dd>
                    <h4>爱德华幼儿园</h4>
                    <p>
                      爱德华幼儿园位于四平市铁西区星源城内，毗邻西湖水上公园，是一家坐拥在公园里的幼儿园，尽享足不出户的天然氧吧。
                    </p>
                    <p>
                      我园建筑面积达4000平米，投入建设资金1000万元，拥有12个宽敞明亮的班级，计划招生适龄儿童300名。其中，我园所采用的新风系统，可保障室内外空气的一致性；中央空调系统，可让孩子不再受季节限制，身处事宜恒温中；而浩泽净水系统，则可确保幼儿的饮水避免水质污染，并达到恒温直饮；当然紫外消毒系统必不可少，确保每日消杀工作高质量全方为的开展。
                    </p>
                  </dd>
                </dl>
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/06.png" alt="" /></dt>
                  <dd>
                    <h4>内蒙通辽合伙人园所</h4>
                    <p>建筑面积6000平米，室外活动场地12000平米。</p>
                    <p>
                      室内设有星空剧场、钢琴教室、国学馆、美术馆、亲自烘焙、沙盘教室、感统教室、科学连廊等；
                    </p>
                    <p>
                      室外设备有动物园、戏水泳池、亲子种植园、大型体能拓展设施、轮滑场等；
                    </p>
                    <p>
                      以合伙人提供的融合主体课程、国际英文课程为主，辅以生活家美术课和自研国学课和感统课，形成独有的课程特色体系；
                    </p>
                    <p>
                      KA给到资深教育投资者更多在高端国际园所的运营经验和系统标准。
                    </p>
                  </dd>
                </dl>
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/08.png" alt="" /></dt>
                  <dd>
                    <h4>贝林斯顿国际幼儿园</h4>
                    <p>
                      贝林斯顿国际幼儿园，位于镇江市丹徒区架鼓山路19号，是集2-6岁幼儿育教为一体的全日制幼儿园。占地面积
                      5000多平米，户外活动场地约 4500
                      平米，全校实时监控、红外线防护。作为当地高端的国际园，致力于为孩子打造一个具有国际视野、卓越领袖能力培养的的乐园。
                    </p>
                    <p>
                      融合了国际蒙台梭利教育课程、STEAM课程、ABCD儿童教育启蒙、CPA课程、自然（森系）课程、KA课程体系的基础上，创设了纯正的蒙氏教学环境，构成一套完整的幼儿园国际双语教育课程，使孩子们在学习母语的同时真正扎实地掌握中英双语。学会一种技能固然很好，但更重要的是学习如何掌握技能的方法。幼儿园坚信孩子与生俱来的创造性天赋是启迪她们最好的方法，关注的不仅仅是课程的学习或者是技能的培养，更重要的是关心孩子的整个生活以及优良品格的培养。
                    </p>
                  </dd>
                </dl>
                <dl class="swiper-slide">
                  <dt><img src="../assets/case/07.png" alt="" /></dt>
                  <dd>
                    <h4>许昌KA儿童之家幼儿园</h4>
                    <p>
                      许昌KA儿童之家幼儿园位于许昌市魏都区解放北路天基幸福里1号楼真善美教育中心内,
                      地理位置优越交通便利。园所建筑面积约为3000m²,
                      户外活动场地约为500m²
                      。我们联合国内一流的设计施工团队，严格遵照教育部2016年颁发的《幼儿园工作规程》及北京伊顿国际幼儿园提供的装修指导,
                      精心设计打造了可容纳10个班级的教室，以及配套的国际文化教室和艺术发展教室，
                      装修主材均依照美国名校“Kids R
                      Kids”幼儿园装修标准采购，施工及验收。可以完全满足国家环保及幼儿园室内装修安全标准。
                    </p>
                    <p>
                      园所教学区内均配备格力环保分体中央空调和热交换新风系统，保证一年四季室内温度舒适，空气质量优良。为满足室外污染天气下幼儿的运动需要，园所特别设置了室内体能教室，在保证幼儿安全健康的前提下保证每天运动量需求。
                    </p>
                  </dd>
                </dl>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
      </div>
      <div class="partner">
        <div class="title">
          <h4>合作伙伴声音</h4>
          <img src="../assets/case/title_02.png" alt="" />
        </div>
        <div class="partner-cont">
          <div class="partner-mar">
            <dl
              v-for="(item, index) in items"
              :key="index"
              :class="{ active: activeIndex === index }"
              @mouseenter="showCont(index)"
            >
              <dt><img :src="item.url" alt="" /><span class="round"></span></dt>
              <dd>
                <h4>{{ item.name }}</h4>
                <p>{{ item.address }}</p>
              </dd>
            </dl>
          </div>
        </div>
        <div class="partner-box" v-if="activeIndex === 0">
          <p>
            教育从来都不是单行线，KA儿童之家、老师们和孩子们在同一时间里成长。孩子们短了外套，长了见识；少了一些稚嫩，多了几分老成。老师们对蒙台梭利教育本质的理解也越来越深刻，活动组织精彩纷呈，常规教育也条理清晰。KA儿童之家的发展称得上日新月异，量的积累一定会导致质的变化，孩子们的进步如是，KA亦如是。
          </p>
          <p>
            火热的骄阳，火热的心情，火热的365天。2018年最幸运的事就是加入KA儿童之家合伙人合伙园·北京虹城国际幼儿园，2018年9月至2019年3月虹城校园满园率达90%，我们收获了孩子们的充实、愉快、满足和自信；体会到了家长们的信任、满意和支持，这不仅包含着老师们的努力，也包含着KA儿童之家所有工作人员的付出与支持。
          </p>
          <p>
            在这个速成，速朽；热闹，孤独；温暖，残酷的世界里，虹城校园和KA儿童之家一起和孩子们慢下来，去放大无数个细节，去接受每一个瞬间的自己。
          </p>
        </div>
        <div class="partner-box" v-if="activeIndex === 1">
          <p>
            自2018年8月加盟伊顿KA儿童之家以来，让我受益最大的就是真真切切体现到了一个有底蕴、有内涵的品牌，全套的课程及培训体系，完善的运营、教务、市场推广和家长服务指导，让我们轻松立足幼教行业。一年时间总部专家进入我园指导多次，我园教师进入总部学习近20人次，线上学习、内部培训不计其数，教师专业度迅速提升，得到家长一致好评。在总部的指导下幼儿人数稳步升高。生源快速发展的同时，总部不仅给予我们师资专业提升方面的强有力支持，还将园长头疼问题——教师管理轻松解决！复制伊顿KA管理模式，让我们的教师全身心的投入到教育教学，稳定的教师团队、又为生源稳定、园所快速发展打下坚定的基础。
          </p>
        </div>
        <div class="partner-box" v-if="activeIndex === 2">
          <p>
            从最初选品牌，到后来的园所建设，团队组建及现在的幼儿园运行，我始终感觉幸运，选择伊顿KA是我认为做的最正确的选择。考察了一年多的品牌，感受过很多的品牌服务，最终还是认为伊顿KA的品牌实力，教育理念，品牌服务都和我们的想法很默契，选择这样的合作方更方便日后的工作交流，也加快了团队进步的步伐。伊顿的课程非常详细，整个课程覆盖了七大领域八大智能12大区域，更全面的教学体系，更好的促进孩子的身心发展。后期服务方便，督导的尽心尽责更是加快了园所的工作进度，也让幼儿园的整体水平提升了一个新的高度。相信有着总部的支持，森林童话国际幼儿园会有一个更好的发展。
          </p>
        </div>
        <div class="partner-box" v-if="activeIndex === 3">
          <p>
            紫屋夫人国际幼儿园坐落在美丽的科尔沁草原，建筑面积16800平方米，总投资4500万。
          </p>
          <p></p>
          <p>
            作为KA儿童之家项目天使合伙人，我们已与KA一同走过了近两年的时光。我们感动于伊顿国际教育集团在中国17年对于学前教育事业的专注，相信并且认同KA儿童之家的教育理念，与伊顿“一切为了孩子卓越的未来”目标一致，坚持用喜悦、平和、充满爱的心态去工作，营造尊重、接纳、示范的教育环境，用视如己出的爱给我们的孩子最温暖的陪伴。
          </p>
          <p>
            学前教育的发展，任重而道远。我们紫屋国际会与KA儿童之家一起，不断创新、锐意进取，为给孩子们创造更好的未来而努力。
          </p>
        </div>
      </div>
      <div class="joinus">
        <h4>加入我们</h4>
        <p>咨询电话</p>
        <span></span>
      </div>
      <div class="apply">
        <h4>申请获取《园所经营宝典》</h4>
        <Apply />
      </div>
    </div>
  </div>
</template>
<script>
import ApplyForm from "@/components/Common/ApplyForm";
export default {
  name: "Case",
  components: {
    Apply: ApplyForm
  },
  data() {
    return {
      activeIndex: 0,
      items: [
        {
          name: "宋园长",
          address: "北京虹城国际幼儿园",
          url: require("../assets/case/song.png")
        },
        {
          name: "丁园长",
          address: "沧州美吉克国际幼儿园",
          url: require("../assets/case/ding.png")
        },
        {
          name: "杨园长",
          address: "聊城森林童话国际幼儿园",
          url: require("../assets/case/yang.png")
        },
        {
          name: "刘园长",
          address: "通辽紫屋夫人国际幼儿园",
          url: require("../assets/case/liu.png")
        }
      ]
    };
  },
  mounted() {
    new Swiper(".swiper-success", {
      pagination: ".swiper-pagination",
      paginationClickable: ".swiper-pagination",
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev"
    });
  },
  methods: {
    showCont: function(index) {
      this.activeIndex = index;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../base/scss/mixin";
@keyframes breathe {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.title {
  text-align: center;
  h4 {
    margin-bottom: 10px;
    font-weight: normal;
    font-size: 28px;
    color: #1a58a2;
  }
}
.content {
  padding-top: 40px;
}
.success {
  &-bgc {
    height: 470px - 60px;
    padding-top: 60px;
    background: #f2f2f4;
  }
  &-cont {
    width: 1320px;
    margin: 0 auto;

    position: relative;
  }
  .swiper-container {
    width: 1084px;
    height: 400px;
    margin: 0 auto;
  }
  .swiper-slide {
    height: 347px;
    dt {
      float: left;
      width: 515px;
      height: 347px;
      border-radius: 10px;
      background: #1a58a2;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
    dd {
      margin-left: 570px;
      padding-top: 40px;
      color: #091338;
      h4 {
        margin-bottom: 32px;
        font-weight: normal;
        font-size: 28px;
      }
      p {
        line-height: 24px;
        text-align: justify;
        font-size: 14px;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 150px;
    margin-top: 0;
  }
}
.partner {
  height: 735px - 68px;
  padding-top: 68px;
  background: url(../assets/case/partner_bg.png) center top no-repeat;
  .title {
    margin-bottom: 46px;
  }
  &-mar {
    height: 174px;
    margin-right: -16px;
    padding-left: 20px;
    padding-top: 54px;
  }
  &-cont {
    @extend %width;
    dl {
      float: left;
      width: 262px - 2px;
      height: 174px - 2px;
      margin-right: 16px;
      background: #f2f2f4;
      border-radius: 20px 20px 0 0;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
      border: 1px solid #ededed;
      position: relative;
      transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1), z-index 0s 0.25s;
      cursor: default;
      .round {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(../assets/case/round.png) left top no-repeat;
      }
      // 				&:hover {
      // 					.round {
      // 						transform: rotate(360deg);
      // 					}
      // 				}
    }
    dl:hover,
    .active {
      background: #d84457;
      dt {
        width: 150px;
        height: 150px;
        margin-left: -75px;
        img {
          width: 135px;
          height: 135px;
        }
      }
      dd {
        color: #fff;
      }
      .round {
        width: 150px;
        height: 150px;
        background-image: url(../assets/case/round_b.png);
      }
    }
    dt {
      width: 125px;
      height: 126px - 3px;
      padding-top: 3px;
      position: absolute;
      left: 50%;
      top: -60px;
      margin-left: -62px;
      text-align: center;
      overflow: hidden;
      img {
        width: 112px;
        height: 112px;
        z-index: 2;
        position: relative;
      }
    }
    dd {
      padding-top: 96px;
      text-align: center;
      color: #111b3d;
      h4 {
        margin-bottom: 16px;
        letter-spacing: 2px;
        font-weight: normal;
        font-size: 24px;
      }
      p {
        letter-spacing: 1px;
        font-size: 16px;
      }
    }
  }
  &-box {
    //width: 1142px;
    width: 1022px;
    padding: 60px 60px 0;
    margin: 0 auto;
    height: 240px - 60px;
    border-radius: 20px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
    background: url(../assets/case/partner_box.png) left top no-repeat #1a58a2;
    p {
      line-height: 24px;
      font-size: 14px;
      color: #fff;
    }
  }
}
.joinus {
  height: 319px;
  background: url(../assets/case/join.jpg) center top no-repeat;
  border-bottom: 6px solid #1a58a2;
  text-align: center;
  color: #fff;
  h4 {
    display: inline-block;
    border-bottom: 7px solid #1a58a2;
    margin-bottom: 36px;
    padding: 60px 16px 7px;
    font-weight: normal;
    font-size: 36px;
  }
  p {
    margin-bottom: 32px;
    font-size: 30px;
  }
  span {
    font-size: 60px;
  }
}
.apply {
  height: 524px - 60px;
  padding-top: 60px;
  background: url(../assets/case/form_bg.png) center top no-repeat;
  h4 {
    margin-bottom: 30px;
    text-align: center;
    font-weight: normal;
    font-size: 30px;
    color: #1a58a2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Case.vue